import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import Join from './join';
import Create from './create';
import Sessions from './sessions';
import SessionForm from './sessionform';
import { uiState } from '../../redux/_constants';
import { useHistory, useLocation } from 'react-router-dom';
import { useQueryParamsAdv } from '../../utilities/query';
import { SessionType, GenderType } from '../../models';

function CreateOrJoin() {
  const [joinId, setJoinId] = useState(null);
  const [setup, setSetup] = useState(null);
  const [gender, setGender] = useState(null);
  const { CREATE, JOIN, START, SESSIONS } = uiState;
  const history = useHistory();
  const location = useLocation();

  // Parse URL parameters for pre-configuration
  const { queryParams } = useQueryParamsAdv(
    {
      type: '',
      gender: '',
      rtnId: '',
      startAt: '',
      sessionKey: '',
      teamA: '',
      teamB: '',
      teamC: '',
      teamD: '',
      teamE: '',
      teamF: '',
      teamG: '',
      teamH: '',
      location: '',
      competition: '',
      alternating: '',
      teamScoring: '',
      judgePanel: '',
      apparatus: '',
      hostId: '',
      hostType: '',
      scorekeepers: '',
      titleSuffix: '',
      title: '',
    },
    true
  );

  // Initialize state from URL params on mount
  useEffect(() => {
    if (
      queryParams.type &&
      Object.values(SessionType).includes(queryParams.type)
    ) {
      setSetup(queryParams.type);
    }
    if (
      queryParams.gender &&
      Object.values(GenderType).includes(queryParams.gender)
    ) {
      setGender(queryParams.gender);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleMode = (mode) => {
    history.push(mode);
  };

  const reset = () => {
    setSetup(null);
    setGender(null);
  };

  const formType = () => {
    switch (location.pathname) {
      case CREATE:
        if (setup === null || gender === null) {
          return (
            <Create
              setSetup={setSetup}
              setGender={setGender}
              setup={setup}
              gender={gender}
            />
          );
        } else {
          return (
            <SessionForm
              setup={setup}
              gender={gender}
              reset={reset}
              initialRtnId={queryParams.rtnId}
              initialStartAt={queryParams.startAt}
              initialSessionKey={queryParams.sessionKey}
              initialTeams={{
                teamA: queryParams.teamA,
                teamB: queryParams.teamB,
                teamC: queryParams.teamC,
                teamD: queryParams.teamD,
                teamE: queryParams.teamE,
                teamF: queryParams.teamF,
                teamG: queryParams.teamG,
                teamH: queryParams.teamH,
              }}
              initialLocation={queryParams.location}
              initialCompetition={queryParams.competition}
              initialAlternating={queryParams.alternating}
              initialTeamScoring={queryParams.teamScoring}
              initialJudgePanel={queryParams.judgePanel}
              initialApparatus={queryParams.apparatus}
              initialHostId={queryParams.hostId}
              initialHostType={queryParams.hostType}
              initialScorekeepers={queryParams.scorekeepers}
              initialTitleSuffix={queryParams.titleSuffix}
              initialTitle={queryParams.title}
            />
          );
        }
      case JOIN:
        return <Join id={joinId} setId={setJoinId} />;
      case SESSIONS:
        return <Sessions />;
      default:
        return null;
    }
  };

  return (
    <Modal
      show={[CREATE, JOIN, SESSIONS].includes(location.pathname)}
      onHide={() => handleMode(START)}
      centered
      dialogClassName="createOrJoinModal"
      animation={false}
      size={[SESSIONS].includes(location.pathname) ? 'lg' : null}
      scrollable={[SESSIONS].includes(location.pathname)}
    >
      {formType()}
    </Modal>
  );
}

export default CreateOrJoin;
